"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayOrderWithCard = void 0;
class PayOrderWithCard {
    constructor(paymentsService) {
        this.paymentsService = paymentsService;
    }
    execute(request) {
        const { idOrder, userRedirectUrl } = request;
        return this.paymentsService.payOrderWithCard({ idOrder, userRedirectUrl });
    }
}
exports.PayOrderWithCard = PayOrderWithCard;
